<template>
  <v-row>
    <v-card max-width="100%" width="100%">
      <v-toolbar color="primary" dark dense>
        <v-tooltip bottom color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="white"
              dark
              v-bind="attrs"
              v-on="on"
            >
              mdi-information-outline
            </v-icon>
          </template>
          <span style="white-space: break-spaces;">{{$t('dd.bufferWeekExplanation')}}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('stats.buffers')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "line" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row wrap>
          <v-col :cols="colSize" v-for="n in bufferCompanies.length" :key="n" style="max-height: 300px">
            <canvas :id="'chart' + (n - 1)"  height="300"></canvas>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import Chart from 'chart.js';
export default {
  name: "Buffers",
  data() {
    return {
      type: "bar",
      charts: [],
      options: {
        hover: {
          mode: 'index',
          intersect: false
        },
        legend: {
          position: "bottom"
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            itemSort: this.labelsSort,
            callbacks: {
              label: this.labelsFormated
            }
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            display: true,
            ticks: {
                beginAtZero: true
            }
          }]
        }
      }
    };
  },
  mounted() {
    setTimeout(() => this.init(), 0)
  },
  beforeDestroy() {
    this.charts.forEach(chart => {
      if (chart) {
        chart.destroy()
        chart = null
      }
    });
  },
  methods: {
    init() {
      this.bufferCompanies.forEach((company, index) => {
        this.render(company, index);
      })
    },
    render(company, index) {
      let data = {
        lables: [],
        datasets : []
      }
      data.labels = this.categories(company)
      data.datasets  = this.series(company)

      let options = Object.assign({}, this.options)
      options.title = {
        display: true,
        text: company.name
      }
      
      if (!this.charts[index]) {
        this.charts[index] = new Chart(document.querySelector("#chart" + index), {
          type: this.type,
          options: options,
          data: data
        })
      }
    },
    categories(company) {
      let categories = [];
      for (let index = 1; index <= company.week; index++) {
        categories.push(this.$t("general.smallWeek") + (index));
        categories.push(this.$t("general.smallWeek") + (index));
        categories.push(this.$t("general.smallWeek") + (index));
      }
      return categories;
    },
    series(company) {
      let series = []
      
      series.push({
        label: this.$t("stats.flowEquation"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: "line",
        lineTension: 0,
        fill: false,
        backgroundColor: '#0000ff',
        borderColor: '#0000ff',
        data: company.data.dd.buffer.flowEquation
      });
      series.push({
        label: this.$t("stats.stock"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: "line",
        lineTension: 0,
        fill: false,
        backgroundColor: '#000000',
        borderColor: '#000000',
        data: company.data.dd.buffer.stock
      });
      series.push({
        label: this.$t("stats.red"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#ff0000',
        stack: 'buffer',
        data: company.data.dd.buffer.red
      });
      series.push({
        label: this.$t("stats.yellow"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#ffff00',
        stack: 'buffer',
        data: this.yellowData(company)
      });
      series.push({
        label: this.$t("stats.green"),
        pointRadius: 0,
				pointHoverRadius: 7,
        type: this.type,
        lineTension: 0,
        backgroundColor: '#008000',
        stack: 'buffer',
        data: this.greenData(company)
      });
      return series;
    },
    async changeType () {
      for (let index = 0; index < this.charts.length; index++) {
        await this.charts[index].destroy()
        this.charts[index] = null
      }

      if (this.type == 'line') {
        this.type = 'bar'
      } else {
        this.type = 'line'
      }
      this.bufferCompanies.forEach((company, index) => {
        this.render(company, index);
      })
    },
    yellowData(company) {
      if (this.type == 'bar') {
        return company.data.dd.buffer.yellow
        } else {
        return company.data.dd.buffer.yellow.map((val, index) => val + company.data.dd.buffer.red[index])
      }
    },
    greenData(company) {
      if (this.type == 'bar') {
        return company.data.dd.buffer.green
        } else {
        return company.data.dd.buffer.green.map((val, index) => val + company.data.dd.buffer.yellow[index] + company.data.dd.buffer.red[index])
      }
    },
    labelsFormated (tooltipItem, data) {
      let label = data.datasets[tooltipItem.datasetIndex].label || '';
      if (label) {
          label += ': ';
      }
      if (tooltipItem.datasetIndex == 3 && this.type == 'bar') {
        label += tooltipItem.yLabel + data.datasets[2].data[tooltipItem.index];
      } else if (tooltipItem.datasetIndex == 4 && this.type == 'bar') {
        label += tooltipItem.yLabel + data.datasets[2].data[tooltipItem.index] + data.datasets[3].data[tooltipItem.index];
      } else {
        label += tooltipItem.yLabel
      }
      return label;
    },
    labelsSort (a, b, data) {
      let aNewValue = a.yLabel
      let bNewValue = b.yLabel
      if (a.datasetIndex == 3 && this.type == 'bar') {
        aNewValue += data.datasets[2].data[a.index];
      } else if (a.datasetIndex == 4 && this.type == 'bar') {
        aNewValue += data.datasets[2].data[a.index] + data.datasets[3].data[a.index];
      }
      if (b.datasetIndex == 3 && this.type == 'bar') {
        bNewValue += data.datasets[2].data[b.index];
      } else if (b.datasetIndex == 4 && this.type == 'bar') {
        bNewValue += data.datasets[2].data[b.index] + data.datasets[3].data[b.index];
      }
      return bNewValue - aNewValue;
    }
  },
  computed: {
    bufferCompanies() {
      return this.$store.getters["game/assignableCompanies"].filter((company) => company.ddOn)
    },
    week() {
      let max = 0;
      this.bufferCompanies.forEach(company => {
        if (company.data.dd.buffer.flowEquation.length > max) {
          max = company.data.dd.buffer.flowEquation.length;
        }
      });
      return max;
    },
    max() {
      let max = 0
      this.bufferCompanies.forEach(company => {
        company.data.value.stock.forEach(stock => {
          if (stock > max) {
            max = stock
          }
        });
      });
      return max;
    },
    colSize() {
      return this.bufferCompanies.length > 1 ? '12' : '12';
    }
  }
};
</script>